import __ from './__';

export default (value: number) => {
  if (value && typeof value !== 'number') {
    return __('Zadajte prosím číslo.');
  }
  return null;
};
